import React, { useState, useEffect, useRef, JSX } from 'react'
import ConsoleNavMenu from '../ConsoleNavMenu';
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';
import './UserSubscription.css'

const UserSubscription = () => {
    const daysLeftForWarning = 10;
    const [subscriptions, setSubscriptions] = useState<Array<AstraModemSubscription>>();
    const [showSubscriptionPlans, setShowSubscriptionPlans] = useState(false);
    const [subscriptionForRenewal, setSubscriptionForReneval] = useState<AstraModemSubscription>();
    const [subscriptionPlans, setSubscriptionPlans] = useState<Array<SubscriptionPlans>>();

    useEffect(() => {
        axios.get<Array<AstraModemSubscription>>(`api/astraSubscription/getSubscriptions`)
            .then(response => {setSubscriptions(response.data)});

        axios.get<Array<SubscriptionPlans>>(`api/astraSubscription/getPlans`)
            .then(response => {setSubscriptionPlans(response.data)});
    }, []);

    function buySubscription(planId: string, subscriptionId: string) {
      axios.post<PaymentInit>('/api/payment/init', {planId, subscriptionId})
      .then(response => {
        console.log(response.data.paymentURL);
        window.open(response.data.paymentURL, '_blank');
      })
    }
    
    return(
        <>
        <ConsoleNavMenu />
        <div className='blocks'>
            <div className='body-box'>
                <table className='table table-striped' aria-labelledby="tabelLabel" style={{tableLayout: "fixed"}}>
                  <thead>
                    <tr>
                      <th style={{width: "30%"}}>Устройство</th>
                      <th style={{width: "30%"}}>Осталось дней</th>
                      <th style={{width: "30%"}}>Срок действия</th>
                      <th style={{width: "20%"}}></th>
                    </tr>
                  </thead>
                  <tbody>
                  {subscriptions?.map(i =>
                      <tr key={i.modemName}>
                        <td>{i.modemName}</td>
                        <td>{i.daysLeft.toFixed()}</td>
                        { i.isRotten ? <td style={{color: "red"}}>{i.timeDeactivation}</td> : <> { i.daysLeft < daysLeftForWarning ? <td style={{color: "orange"}}>{i.timeDeactivation}</td> : <td>{i.timeDeactivation}</td>  } </>}
                        <td><button style={{width: "100%"}} className="btn btn-primary" onClick={() => {setSubscriptionForReneval(i); setShowSubscriptionPlans(true)}}>Продлить</button></td>
                        {/*<td><Link to={`/statistics/modem?imei=${i.imei}`}>{i.imei}</Link></td>*/}
                      </tr>
                  )}
                  </tbody>
                </table> 
            </div>
        </div>
        <Modal size="lg"  show={showSubscriptionPlans} onHide={() => {setShowSubscriptionPlans(false)}}>
            <Modal.Header style={{backgroundColor:"#343434"}} closeButton>
            <Modal.Title>Продление подписки {subscriptionForRenewal?.modemName}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{backgroundColor:"#343434"}}>
              <div className='plans'>
                {subscriptionPlans?.map((x) => 
                <div className='plan'>
                  <div className='plans_row plans_name'>{x.name}</div>
                  <div className='plans_row plans_price'>Стоимость: {x.price} ₽</div>
                  <div><Button style={{width: "-webkit-fill-available"}} variant="primary" onClick = {() => buySubscription(x.id, subscriptionForRenewal?.id ?? "")}>Оплатить</Button></div>
                </div>)}
              </div>
            </Modal.Body>
            <Modal.Footer style={{backgroundColor:"#343434"}}>
            <Button variant="secondary" onClick={() => {setShowSubscriptionPlans(false)}}>
                {/*t('close')*/}Закрыть
            </Button>
            </Modal.Footer>
        </Modal>
        </>
    )
}

export default UserSubscription;